import React from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import PropTypes from 'prop-types';
const Error404 = ({error}) => {
  const route = all_routes;
  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content">
          <div className="error-box">
            <div className="error-img">
              <ImageWithBasePath
                src="assets/img/authentication/error-404.png"
                className="img-fluid"
                alt="Error"
              />
            </div>
            <h3 className="h2 mb-3">Oops, something went wrong</h3>
            <p>{error.message}</p>
            <Link to={route.dashboard} className="btn btn-primary">
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

Error404.propTypes = {
  error: PropTypes.object.isRequired,
};


export default Error404;
